const APP_ROUTES = {
  HOME: "/",
  TOKEN_PAGE: "/token/:token",
  PROJECT_INSTANCE: "/project-instance",
  INSTANCE_NEW: "/project-instance/new",
  INSTANCE_DETAIL: "/project-instance/:id",
  TEST_PACKAGE: "/test-package",
  TEST_PACKAGE_NEW: "/test-package/new",
  TEST_PACKAGE_DETAIL: "/test-package/:id",
  SEQUENCES: "/sequences",
  SEQUENCE_DETAIL: "/sequences/:id",
  ACCESS_DENIED: "/access-denied",
  NOT_FOUND: "/404",
};

export default APP_ROUTES;
